import type { EditorState, SerializedNodes } from "../state/types";
import type { Resolver } from "../resolver/resolver";

export function serializeState(
  state: EditorState,
  resolver: Resolver,
): string {
  return JSON.stringify(serializeNodes(state, resolver));
}

export function serializeNodes(
  state: EditorState,
  resolver: Resolver,
): SerializedNodes {
  const result: SerializedNodes = {};

  for (const [id, node] of Object.entries(state.nodes)) {
    const resolvedName = resolver.reverseLookup(node.data.type);
    if (!resolvedName) {
      console.warn(
        `Could not reverse-resolve component for node ${id}`,
      );
      continue;
    }

    result[id] = {
      type: { resolvedName },
      isCanvas: node.data.isCanvas,
      props: node.data.props,
      displayName: node.data.displayName,
      custom: node.data.custom,
      parent: node.data.parent,
      nodes: node.data.nodes,
      linkedNodes: node.data.linkedNodes,
      hidden: node.data.hidden,
    };
  }

  return result;
}
